import React from 'react';
import Box from '@mui/material/Box'; // Make sure MUI is installed

const LogoComponent = () => {
  return (
    <Box>
      <img src="/assets/adpclear-updated-logo.png" height="40px" alt="logo" />
    </Box>
  );
};

export default LogoComponent;
